<template>
    <!-- 活动弹窗 -->
    <div v-if="value" class="activity-popup-overlay" @click.self="closePopup">
        <div class="activity-popup-container">
            <div class="activity-popup-header">
                <img class="close-btn" @click="closePopup" src="../assets/image/close.png" alt="Close">
            </div>
            <div class="activity-popup-body">
                <iframe :src="getActivityUrl()" frameborder="0" class="activity-iframe" allowfullscreen
                    allowTransparency="true" scrolling="auto" @load="onIframeLoad">
                </iframe>
                <div v-if="loading" class="iframe-loading">
                    <i class="fa fa-spinner fa-spin"></i> Loading...
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Base64,
    isNotEmpty,
    getActivityApiDomain,
    checkOldActivityEnabled
} from '../utils/index.js'
const ACTVITY_URL_MAP = {
    cztxkr: "https://cztxkr.kodaduck.com/activity/index.html",
    cztxtw: "https://cztxtw.dustyx.com/discountActivity/index.html",
    mym2ru: "https://mym2ru.wulagame.com/activity/index.html",
    slzhsru: "https://slzhsru.wulagame.com/activity/index.html",
    tgru: "https://tgru.wulagame.com/activity/index.html",
    m2en: "https://m2en.luckyyx.com/activity/index.html",
    lycqkr: "https://lycqkr.kodaduck.com/activity/index.html",
    lycqts: "https://lycqkr.kodaduck.com/activity/index.html"

}

export default {
    name: 'ActivityPopup',
    props: {
        value: Boolean
    },
    data() {
        return {
            loading: true,
            hasLogin: this.$session.hasLogin(),
            gameData: this.$store.state.gameData,
            loginData: this.$cache.getLoginData(),
            roleInfo: this.$cache.getRoleInfo(),
        }
    },
    watch: {
        value(val) {
            this.handleScroll(val);
            if (val) this.$analytics.track('activity_opened', { activity_id: 'external_activity', activity_name: '站外活动弹窗', activity_type: 'external_iframe' });
            if (!val) this.loading = false;
        }
    },
    methods: {
        closePopup() {
            this.$analytics.track('activity_closed', { activity_id: 'external_activity', activity_type: 'external_iframe' });
            this.$emit('input', false);
            this.handleScroll(false);
        },
        onIframeLoad() {
            this.loading = false;
        },
        handleScroll(val) {
            if (val) {
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
                document.documentElement.style.overflow = '';
            }
        },
        // 检查抽奖次数并在有次数时自动打开弹窗
        async checkActivityLottery() {
            if (this.hasLogin && isNotEmpty(this.roleInfo)) {
                const shouldRun = await checkOldActivityEnabled(this.$axios, this.gameData.gameCode);
                if(shouldRun){
                // if ( this.gameData.gameCode === 'cztxkr' || this.gameData.gameCode === 'mym2ru' || this.gameData.gameCode === 'tgru') {
                    try {

                        // 使用封装方法获取 session（若未登录则不调用）
                        const session = this.getSessionBase64();
                        if (!session) return;
                        console.log('Checking activity eligibility for gameCode:', this.$cache.getLoginData().isTest,this.gameData.gameCode);
                        // if(this.gameData.gameCode === 'lycqkr' && !this.$cache.getLoginData().isTest) return false; // 测试标记，实际使用时请移除
                        const url = `${getActivityApiDomain()}/api/game-act/init-data?session=${encodeURIComponent(session)}`;
                        const res = await this.$axios.get(url);
                        if (res && res.successful) {
                            const count = res.data.lotteryCount;
                            if (typeof count === 'number' && count > 0) {
                                // 通过 v-model 打开弹窗
                                this.$emit('input', true);
                            }
                        }
                    } catch (err) {
                        console.error('ActivityPopup.checkActivityLottery error', err);
                    }
                }
            }
        },
        // 返回 Base64 编码的 session 字符串，若未登录或数据缺失返回 null
        getSessionBase64() {
            if (!this.hasLogin || !this.loginData) return null;
            const role = this.roleInfo;
            const sessionToken = {
                userId: this.loginData.userId,
                loginToken: this.loginData.loginToken,
                gameCode: this.gameData.gameCode,
                serverCode: role.serverCode,
                roleId: role.roleId,
                roleName: role.roleName,
                loginTimestamp: this.loginData.loginTimestamp
            };
            try {
                return Base64.encode(JSON.stringify(sessionToken));
            } catch (e) {
                console.error('getSessionBase64 error', e);
                return null;
            }
        },
        getActivityUrl() {
            let url = ACTVITY_URL_MAP[this.gameData.gameCode];
            if (this.hasLogin) {
                const base64Token = this.getSessionBase64();
                if (base64Token) return url + `?session=${encodeURIComponent(base64Token)}`;
            }
            return url;
        },
    }
    ,
    mounted() {
        // 组件挂载后检查抽奖次数
        this.checkActivityLottery();
    }
}
</script>

<style scoped></style>
